import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var ErrorMessageConfig = /*#__PURE__*/function () {
  function ErrorMessageConfig(httpMessageConfig, defaultMessage) {
    _classCallCheck(this, ErrorMessageConfig);

    /**
     * @type {HttpErrorMessageConfig}
     */
    this.httpMessageConfig = httpMessageConfig;
    /**
     * @type {string}
     */

    this["default"] = defaultMessage;
    /**
     * @type {?function(error)}
     */

    this.custom = null;
  }
  /**
   * @returns {?function(error)}
   */


  _createClass(ErrorMessageConfig, [{
    key: "getCustom",
    value: function getCustom() {
      return this.custom;
    }
    /**
     * @param {?function(error)} value
     *
     * @returns {this}
     */

  }, {
    key: "setCustom",
    value: function setCustom(value) {
      this.custom = value;
      return this;
    }
    /**
     * @returns {HttpErrorMessageConfig}
     */

  }, {
    key: "getHttpMessageConfig",
    value: function getHttpMessageConfig() {
      return this.httpMessageConfig;
    }
    /**
     * @returns {?string}
     */

  }, {
    key: "getDefault",
    value: function getDefault() {
      return this["default"];
    }
    /**
     * @param {?string} value
     *
     * @returns {this}
     */

  }, {
    key: "setDefault",
    value: function setDefault(value) {
      this["default"] = value;
      return this;
    }
  }]);

  return ErrorMessageConfig;
}();

export { ErrorMessageConfig as default };